var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMangueraReposo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1924 1.08762L1.77933 7.81423C0.639589 8.3841 0.00056076 9.54843 0.00056076 10.8229V20.566C0.00056076 22.4572 1.5256 22.396 2.28813 22.1291L6.72717 20.2929C10.0905 18.9003 13.376 15.2019 13.376 10.8229C13.376 10.409 13.1992 10.0222 13.0626 9.65648L18.1708 7.10478C19.8327 6.27384 20.5161 4.25375 19.6851 2.59186C18.8542 0.931649 16.8576 0.253315 15.1924 1.08762Z",
    fill: "#47B4E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMangueraReposo);
export default __webpack_public_path__ + "static/media/manguera_reposo.91f3f23d52f4191056c58dc385da7292.svg";
export { ForwardRef as ReactComponent };